import {
  createError,
  defineNuxtRouteMiddleware,
  useAsyncData,
  useNuxtData,
} from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useMasterPPScale } from '../composables/useMasterPPScale/useMasterPPScale'
import { PRODUCT as ROUTE_NAMES } from '../route-names'

export const masterPPScale = defineNuxtRouteMiddleware(async (to) => {
  const { slug } = to.params
  const $httpFetch = useHttpFetch()
  const { isMasterPPScaleExperimentActive, isMasterPPScaleFeatureEnabled } =
    useMasterPPScale(to)

  const { data, error } = await useAsyncData(
    `MasterPP-${slug}`,
    async () => {
      if (
        !isMasterPPScaleFeatureEnabled.value &&
        !isMasterPPScaleExperimentActive.value
      ) {
        return null
      }

      if (to.name !== ROUTE_NAMES.MASTER_PP) {
        return null
      }

      return $httpFetch('/product-page/parent-products/:slug', {
        pathParams: { slug: `${slug}` },
      })
    },
    {
      getCachedData: (key) => useNuxtData(key).data.value || undefined,
    },
  )

  if (error.value || !data.value?.productId) {
    throw createError({
      statusCode: error.value?.statusCode || 404,
      statusMessage: '[PRODUCT] Master PP Product id not found',
      fatal: true,
    })
  }
})
